// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { TRAFFIC_ACCESS_STATE_DEFAULT, TrafficAccessStateModel } from './traffic-access.model';

@State({ name: 'TrafficAccess', defaults: TRAFFIC_ACCESS_STATE_DEFAULT })
@Injectable()
export class TrafficAccessState {


  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateTrafficsAccess(roles: PermissionEnum[], user: UserModel): TrafficAccessStateModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: TrafficAccessStateModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): TrafficAccessStateModel {
    switch (role) {
      case PermissionEnum.CAN_SAVE_FORCE:
        return {
          ...TRAFFIC_ACCESS_STATE_DEFAULT,
          canSaveForce: true
        };
      case PermissionEnum.CAN_READ_TALONS_BY_ID:
        return {
          ...TRAFFIC_ACCESS_STATE_DEFAULT,
          canReadTrafficById: true
        };
      case PermissionEnum.CAN_READ_TALONS:
        return {
          ...TRAFFIC_ACCESS_STATE_DEFAULT,
          canReadTraffic: true
        };
      case PermissionEnum.CAN_WRITE_TALONS:
        return {
          ...TRAFFIC_ACCESS_STATE_DEFAULT,
          canWriteTraffics: true
        };
      case PermissionEnum.SUPER_USER:
        return {
          canReadTraffic: true,
          canSaveForce: true,
          canWriteTraffics: true,
          canReadTrafficById: true,
          canRemoveTemplate: true
        };
      default: {
        return {
          ...TRAFFIC_ACCESS_STATE_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: TrafficAccessStateModel[]): TrafficAccessStateModel {
    const moduleConfig: TrafficAccessStateModel = TRAFFIC_ACCESS_STATE_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadTraffic = moduleConfig.canReadTraffic ? true : config.canReadTraffic;
      moduleConfig.canReadTrafficById = moduleConfig.canReadTrafficById ? true : config.canReadTrafficById;
      moduleConfig.canSaveForce = moduleConfig.canSaveForce ? true : config.canSaveForce;
      moduleConfig.canWriteTraffics = moduleConfig.canWriteTraffics ? true : config.canWriteTraffics;
      moduleConfig.canRemoveTemplate = moduleConfig.canRemoveTemplate ? true : config.canRemoveTemplate;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToTraffics(profileState: ProfileStateModel, accessState: AccessStateModel): TrafficAccessStateModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return TrafficAccessState.generateTrafficsAccess(roleList, userData);
  }
}


